import requestServer from '../request-server';

let internals = {};

internals.trialSubscribe = function (data) {
  return requestServer(
    'v1/trial/subscription',
    data,
    'POST',
    {},
    'application/json',
    true
  );
};

internals.payment = function (data) {
  return requestServer(
    'v1/user/payments',
    data,
    'POST',
    {},
    'application/json',
    true
  );
};
internals.paymentHistory = function (data) {
  const query = new URLSearchParams(data).toString();

  return requestServer(
    `v1/user/payments?${query}`,
    '',
    'GET',
    {},
    'application/json',
    true
  );
};

internals.paymentStatusVerify = function (data) {
  return requestServer(
    'v1/user/payments/verify',
    data,
    'POST',
    {},
    'application/json',
    true
  );
};

internals.subscriptionDropdowns = function (data) {
  return requestServer(
    'v1/api/subscription/dropdowns',
    '',
    'GET',
    {},
    'application/json',
    true
  );
};

export default internals;
